import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Input, InputPicker, Pagination } from "rsuite";
import { createAPIEndpoint } from "../../API/authenticated.request";
import { exportAddAtom } from "../../Atoms/exportAdd.atom";
import ExportAdd from "../../Components/Common/ExportAdd";
import Filter from "../../Components/Common/Filter";
import Grid from "../../Components/Grid/index";
import Responsive from "../../Components/Responsive";
import { cities } from "../../data/dataHotels";
import { HotelModel } from "../../Models/Hotel";
import AddEdit from "./AddEdit";

const Hotels = () => {
  //---------------------------States
  const [filterModel, setfilterModel] = useState({ q: "", take: 20, page: 1 });
  const [Hotels, setHotels] = useState([]);
  const [model, setmodel] = useState(new HotelModel());
  const [state, setstate] = useRecoilState(exportAddAtom);
  const [totalCount, setTotalCount] = useState(0);
  //---------------------------
  const reset = () => {
    setmodel(new HotelModel());
    setstate((prev) => ({ ...prev, open: false }));
  };
  //---------------------------
  const getHotels = () => {
    createAPIEndpoint("CrmTaskin", filterModel)
      .fetch()
      .then((res) => {
        setHotels(res.data.data);
        setTotalCount(res.data.totalCount);
      })
      .catch((err) => console.log(err));
  };
  const getById = (id) => {
    createAPIEndpoint("CrmTaskin")
      .fetchById(id)
      .then((res) => {
        setmodel(res.data);
      })
      .catch((err) => console.log(err));
  };
  const save = () => {
    if (model.id) {
      createAPIEndpoint("CrmTaskin")
        .updateWithId(model.id, { ...model })
        .then((res) => {
          getHotels();
          reset();
        })
        .catch((err) => console.log(err));
    } else
      createAPIEndpoint("CrmTaskin")
        .create({ ...model })
        .then((res) => {
          getHotels();
          reset();
        })
        .catch((err) => console.log(err));
  };
  const Delete = (id) => {
    createAPIEndpoint("CrmTaskin")
      .delete(id)
      .then(() => getHotels())
      .catch((err) => console.log(err));
  };
  //--------------------------------

  useEffect(() => {
    getHotels();
  }, []);
  return (
    <div className="p-10">
      <div style={{ width: "99%", margin: "auto", marginTop: "12px" }}>
        <Filter search={getHotels}>
          <Responsive className="p-10" m={4} l={4} xl={4}>
            <label>Nom: </label>
            <Input
              value={filterModel.q}
              placeholder="Rechercher"
              onChange={(q) => {
                setfilterModel((prev) => {
                  return { ...prev, q, page: 1 };
                });
              }}
            />
          </Responsive>
          <Responsive m={4} l={4} xl={4} className="p-10">
            <label> Cité: </label>
            <InputPicker
              block
              placeholder="Rechercher"
              data={cities}
              onChange={(city) => {
                setfilterModel((prev) => {
                  return { ...prev, city, page: 1 };
                });
              }}
            />
          </Responsive>
        </Filter>
      </div>
      <ExportAdd
        size={"xs"}
        noExport
        noimportExcel
        button
        title={"إضافة فندق"}
        save={save}
        AddComponent={<AddEdit model={model} _setmodel={setmodel} />}
      />
      <Grid
        noAdvancedActions
        columns={colomns}
        rows={Hotels}
        actionKey="id"
        editAction={(id) => {
          setstate((prev) => ({ ...prev, open: true }));
          getById(id);
        }}
        deleteAction={(id) => {
          Delete(id);
        }}
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[25, 50, 100, 300]}
          limit={filterModel.take}
          activePage={filterModel.page}
          onChangePage={(page) => {
            setfilterModel((prev) => {
              return { ...prev, page };
            });
            createAPIEndpoint("CrmTaskin", { ...filterModel, page })
              .fetch()
              .then((res) => {
                setHotels(res.data.data);
                setTotalCount(res.data.totalCount);
              })
              .catch((err) => console.log(err));
          }}
          onChangeLimit={(take) => {
            setfilterModel((prev) => {
              return { ...prev, take, page: 1 };
            });
            createAPIEndpoint("CrmTaskin", { ...filterModel, take, page: 1 })
              .fetch()
              .then((res) => {
                setHotels(res.data.data);
                setTotalCount(res.data.totalCount);
              })
              .catch((err) => console.log(err));
          }}
        />
      </div>
    </div>
  );
};

export default Hotels;
const colomns = [
  { name: "Nom", value: "name", render: (v) => <div>{v}</div> },
  { name: "الاسم", value: "name_ar", render: (v) => <div>{v}</div> },
  {
    name: "cité",
    value: "isMakkah",
    render: (v) => <div>{v == 1 ? "Makkah" : "Madinah"}</div>,
  },
];
